/*
 *  REST Service object: BoardRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { doGetPromise, filterParams } from '../../config/core.httpclient-utils';
@Injectable()
export class BoardRest {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    getBoard(boardId: number = 0) {
        return doGetPromise(this.http, `/api/board/${boardId}`);
    }

    getBoards(queryData: any) {
        let params = filterParams(
            queryData,
            ["boardName", "isShared", "page_num", 
             "page_size", "project", "section",
             "sort_dir", "sort_field", "unixName"]
        );
        return doGetPromise(this.http, '/api/board', params);
    }

    postBoard(boardId: number = 0, boardData: any) {
        return this.http.post(`/api/board/${boardId}`, boardData)
        .toPromise();
    }

    deleteBoard(boardId: number = 0) {
        return this.http.delete(`/api/board/${boardId}`)
        .toPromise();  
    }
}

